import requestAction from '../../utils/requestAction'

export const fetchCarriers = (params: string) =>
  requestAction('CARRIER_LIST', params)(`carriers`, 'GET')
